import { Injectable } from "@angular/core";

@Injectable()
export class ApplicationStorage{
    
    storage:Map<string, string> = new Map();


}